import { createReducer } from '@reduxjs/toolkit';
import {
  GETTING_LIST_SUCCEEDED,
  GETTING_LIST_FAILED,
  DELETING_LIST_SUCCEEDED,
  DELETING_LIST_FAILED,
  UPDATE_LIST_NAME,
  UPDATING_LIST_NAME_SUCCEEDED,
  UPDATING_LIST_NAME_FAILED,
  CREATING_LIST_SUCCEEDED,
  CREATING_LIST_FAILED,
  GET_ACTIVE_SUBSCRIBERS,
  GETTING_ACTIVE_SUBSCRIBERS_SUCCEEDED,
  GETTING_ACTIVE_SUBSCRIBERS_FAILED,
  CREATING_SUBSCRIBER_LIST_SUCCEEDED,
  CREATING_SUBSCRIBER_LIST_FAILED,
  UPDATING_SUBSCRIBER_LIST_SUCCEEDED,
  UPDATING_SUBSCRIBER_LIST_FAILED,
  GETTING_ADDITIONAL_PROFILE_LIST_SUCCEEDED,
  GETTING_ADDITIONAL_PROFILE_LIST_FAILED,
  GET_SUPPRESSED_SUBSCRIBERS,
  GETTING_SUPPRESSED_SUBSCRIBERS_SUCCEEDED,
  GETTING_SUPPRESSED_SUBSCRIBERS_FAILED,
  ACTIVATE_SUBSCRIBER_SUCCEEDED,
  ACTIVATE_SUBSCRIBER_FAILED,
  SUPPRESS_SUBSCRIBER_SUCCEEDED,
  SUPPRESS_SUBSCRIBER_FAILED,
  REMOVING_SUBSCRIBER_SUCCEEDED,
  REMOVING_SUBSCRIBER_FAILED,
  DELETING_ALL_SUBSCRIBERS_SUCCEEDED,
  DELETING_ALL_SUBSCRIBERS_FAILED,
  IMPORT_FILE,
  IMPORT_FILE_SUCCEEDED,
  IMPORT_FILE_FAILED,
  GETTING_SAMPLE_FILE_SUCCEEDED,
  GETTING_SAMPLE_FILE_FAILED,
  DOWNLOADED_SAMPLE_FILE,
  RESET_SNACKBAR,
  GET_SEGMENTED_LIST,
  GETTING_SEGMENTED_LIST_SUCCEEDED,
  GETTING_SEGMENTED_LIST_FAILED,
  CREATING_SEGMENTED_LIST_SUCCEEDED,
  CREATING_SEGMENTED_LIST_FAILED,
  UPDATING_SEGMENTED_LIST_SUCCEEDED,
  UPDATING_SEGMENTED_LIST_FAILED,
  DELETING_SEGMENTED_LIST_SUCCEEDED,
  DELETING_SEGMENTED_LIST_FAILED,
  GETTING_IMPORT_STATUS_LIST_SUCCEEDED,
  GETTING_IMPORT_STATUS_LIST_FAILED,
  GET_IMPORT_STATUS_LIST,
  GETTING_PAGINATED_LISTS_SUCCEEDED,
  GETTING_PAGINATED_LISTS_FAILED,
  GET_PAGINATED_LISTS,
  GET_PAGINATED_SEGMENTED_LISTS,
  GETTING_PAGINATED_SEGMENTED_LISTS_SUCCEEDED,
  GETTING_PAGINATED_SEGMENTED_LISTS_FAILED,
  SET_CURRENT_LIST,
  GET_FILE_NAME_IMPORT_STATUS,
  GETTING_FILE_NAME_IMPORT_STATUS_SUCCEEDED,
  GETTING_FILE_NAME_IMPORT_STATUS_FAILED,
  RESET_GET_FILE_NAME_STATUS,
  RESET_IMPORT_SUCCEEDED,
  GET_ERROR_FILE,
  GETTING_ERROR_FILE_SUCCEEDED,
  GETTING_ERROR_FILE_FAILED,
  GET_SAMPLE_FILE,
  DOWNLOADED_ERROR_FILE,
  CLEAR_LIST_STORE,
  GET_ALL_LISTS,
  GETTING_ALL_SEGMENTED_LISTS_SUCCEEDED,
  GETTING_ALL_SEGMENTED_LISTS_FAILED,
  GETTING_ALL_LISTS_SUCCEEDED,
  GETTING_ALL_LISTS_FAILED,
  GET_ALL_SEGMENTED_LISTS,
  RESET_LISTS_DATA,
  UPDATE_LIST_FILTERS,
  RESET_LIST_FILTERS
} from './actions';

const initialState = {
  subscribersList: {
    getting: false,
    listsData: [],
    currentList: {},
    deleted: false,
    savedName: false,
    updatingName: false,
    updatedName: false,
    listCreated: false,
    listUpdated: false,
    error: {}
  },
  profileList: {
    getting: false,
    activeSubscribers: [],
    suppressedSubscribers: [],
    deleted: false,
    activatedOrSuppressed: false
  },
  additionalProfileList: {
    profileList: {},
    error: {}
  },
  segmentedList: {
    getting: false,
    listsData: [],
    currentList: {},
    saved: false,
    deleted: false,
    error: {}
  },
  importStatusList: {
    getting: false,
    listsData: [],
    error: {}
  },
  fileNameStatus: {
    getting: false,
    isFileProcessing: false,
    gettingSucceeded: false
  },
  errorFile: {
    getting: false,
    file: {},
    gettingSucceeded: false,
    isDownloading: false
  },
  sampleFile: {
    getting: false,
    gettingFileSucceeded: false,
    sampleFileBlob: {},
    isDownloading: false
  },
  showSnackbar: false,
  isImportingFile: false,
  isImportSucceeded: false,
  allLists: {
    getting: false,
    current: []
  },
  allSegmentedLists: {
    getting: false,
    current: []
  },
  filters: {
    searchInput: '',
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTemplates: []
  }
};

export default createReducer(initialState, {
  [GET_PAGINATED_LISTS]: state => {
    state.subscribersList = {
      ...state.subscribersList,
      getting: true,
      deleted: false,
      savedName: false
    };
    return state;
  },
  [GETTING_PAGINATED_LISTS_SUCCEEDED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      getting: false,
      listsData: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_LISTS_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      getting: false,
      listsData: [],
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [GETTING_LIST_SUCCEEDED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      currentList: action.payload
    };
    return state;
  },
  [GETTING_LIST_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      currentList: {},
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [DELETING_LIST_SUCCEEDED]: state => {
    state.subscribersList = {
      ...state.subscribersList,
      deleted: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Deleted Successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [DELETING_LIST_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      deleted: false
    };
    state.showSnackbar = true;
    state.snackbarMessage =
      action.payload.response.status === 400
        ? 'Failed to delete. Please delete the templates/surveys associated to the list and try again.'
        : 'Failed to delete. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [UPDATE_LIST_NAME]: state => {
    state.subscribersList = {
      ...state.subscribersList,
      updatingName: true
    };
    return state;
  },
  [UPDATING_LIST_NAME_SUCCEEDED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      currentList: action.payload,
      updatingName: false,
      updatedName: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Updated Successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [UPDATING_LIST_NAME_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      updatingName: false,
      updatedName: false,
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    state.showSnackbar = true;
    state.snackbarMessage =
      action.payload.response.status === 409
        ? 'List name already exists. Try again with a new name.'
        : 'Failed to save. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [CREATING_LIST_SUCCEEDED]: state => {
    state.subscribersList = {
      ...state.subscribersList,
      savedName: true
    };
    state.snackbarMessage = 'Saved successfully.';
    state.snackbarSeverity = 'success';
    state.showSnackbar = true;
    return state;
  },
  [CREATING_LIST_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      savedName: false,
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    state.snackbarMessage =
      action.payload.response.status === 409
        ? 'List name already exists. Try again with a new name.'
        : 'Failed to save. Try again.';
    state.snackbarSeverity = 'error';
    state.showSnackbar = true;
    return state;
  },
  [SET_CURRENT_LIST]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      currentList: action
    };
    return state;
  },
  [GET_ACTIVE_SUBSCRIBERS]: state => {
    state.profileList = {
      ...state.profileList,
      getting: true,
      deleted: false,
      activatedOrSuppressed: false
    };
    state.subscribersList = {
      ...state.subscribersList,
      listCreated: false,
      listUpdated: false
    };
    return state;
  },
  [GETTING_ACTIVE_SUBSCRIBERS_SUCCEEDED]: (state, action) => {
    state.profileList = {
      ...state.profileList,
      getting: false,
      activeSubscribers: action.payload,
      suppressedSubscribers: []
    };
    return state;
  },
  [GETTING_ACTIVE_SUBSCRIBERS_FAILED]: (state, action) => {
    state.profileList = {
      ...state.profileList,
      getting: false,
      activeSubscribers: [],
      suppressedSubscribers: [],
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [CREATING_SUBSCRIBER_LIST_SUCCEEDED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      listCreated: true,
      currentList: { ...action.payload }
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Subscriber created successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [CREATING_SUBSCRIBER_LIST_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      listCreated: false,
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    state.snackbarMessage =
    action.payload.response.status === 409
    ? 'Subscriber list already exists. Try again.'
    : 'Failed to save. Try again.';
    state.snackbarSeverity = 'error';
    state.showSnackbar = true;
    return state;
  },
  [UPDATING_SUBSCRIBER_LIST_SUCCEEDED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      listUpdated: true,
      currentList: { ...action.payload }
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Subscriber updated successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [UPDATING_SUBSCRIBER_LIST_FAILED]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      listUpdated: false,
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    state.snackbarMessage =
    action.payload.response.status === 409
    ? 'Subscriber list already exists. Try again.'
    : 'Failed to save. Try again.';
    state.snackbarSeverity = 'error';
    state.showSnackbar = true;
    return state;
  },
  [GETTING_ADDITIONAL_PROFILE_LIST_SUCCEEDED]: (state, action) => {
    state.additionalProfileList = {
      ...state.additionalProfileList,
      profileList: action.payload
    };
  },
  [GETTING_ADDITIONAL_PROFILE_LIST_FAILED]: (state, action) => {
    state.additionalProfileList = {
      ...state.additionalProfileList,
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
  },
  [GET_SUPPRESSED_SUBSCRIBERS]: state => {
    state.profileList = {
      ...state.profileList,
      getting: true,
      deleted: false,
      activatedOrSuppressed: false
    };
    return state;
  },
  [GETTING_SUPPRESSED_SUBSCRIBERS_SUCCEEDED]: (state, action) => {
    state.profileList = {
      ...state.profileList,
      getting: false,
      activeSubscribers: [],
      suppressedSubscribers: action.payload
    };
    return state;
  },
  [GETTING_SUPPRESSED_SUBSCRIBERS_FAILED]: (state, action) => {
    state.profileList = {
      ...state.profileList,
      getting: false,
      activeSubscribers: [],
      suppressedSubscribers: [],
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [ACTIVATE_SUBSCRIBER_SUCCEEDED]: state => {
    state.profileList = {
      ...state.profileList,
      activatedOrSuppressed: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Activated subscriber successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [ACTIVATE_SUBSCRIBER_FAILED]: state => {
    state.profileList = {
      ...state.profileList,
      activatedOrSuppressed: false
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Failed to activate subscriber. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [SUPPRESS_SUBSCRIBER_SUCCEEDED]: state => {
    state.profileList = {
      ...state.profileList,
      activatedOrSuppressed: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Suppressed subscriber successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [SUPPRESS_SUBSCRIBER_FAILED]: state => {
    state.profileList = {
      ...state.profileList,
      activatedOrSuppressed: false
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Failed to suppress subscriber. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [REMOVING_SUBSCRIBER_SUCCEEDED]: state => {
    state.profileList = {
      ...state.profileList,
      deleted: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Removed Successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [REMOVING_SUBSCRIBER_FAILED]: state => {
    state.profileList = {
      ...state.profileList,
      deleted: false
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Unable to remove. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [DELETING_ALL_SUBSCRIBERS_SUCCEEDED]: state => {
    state.profileList = {
      ...state.profileList,
      deleted: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Deleted Successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [DELETING_ALL_SUBSCRIBERS_FAILED]: state => {
    state.profileList = {
      ...state.profileList,
      deleted: false
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Unable to delete. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [IMPORT_FILE]: state => {
    state.fileNameStatus = {
      ...state.fileNameStatus,
      getting: false,
      isFileProcessing: false,
      gettingSucceeded: false
    };
    state.isImportingFile = true;
    state.showSnackbar = false;
    return state;
  },
  [IMPORT_FILE_SUCCEEDED]: state => {
    state.showSnackbar = true;
    state.snackbarMessage = 'File is queued and will be processed.';
    state.snackbarSeverity = 'success';
    state.isImportSucceeded = true;
    state.isImportingFile = false;
    return state;
  },
  [IMPORT_FILE_FAILED]: state => {
    state.showSnackbar = true;
    state.snackbarMessage =
      'Failed to process file. Check Import status for more info and try again';
    state.snackbarSeverity = 'error';
    state.isImportSucceeded = false;
    state.isImportingFile = false;
    return state;
  },
  [GET_SAMPLE_FILE]: state => {
    state.sampleFile = {
      getting: true,
      isDownloading: true,
      gettingFileSucceeded: false,
      sampleFileBlob: {}
    };
    return state;
  },
  [GETTING_SAMPLE_FILE_SUCCEEDED]: (state, action) => {
    state.sampleFile = {
      getting: false,
      gettingFileSucceeded: true,
      sampleFileBlob: action.payload
    };
    return state;
  },
  [GETTING_SAMPLE_FILE_FAILED]: state => {
    state.sampleFile = {
      getting: false,
      gettingFileSucceeded: false,
      sampleFileBlob: {}
    };
    return state;
  },
  [DOWNLOADED_SAMPLE_FILE]: state => {
    state.sampleFile = {
      ...state.sampleFile,
      isDownloading: false,
      gettingFileSucceeded: false,
      sampleFileBlob: {}
    };
    return state;
  },
  [RESET_SNACKBAR]: state => {
    state.showSnackbar = false;
    return state;
  },
  [GET_PAGINATED_SEGMENTED_LISTS]: state => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: true,
      currentList: {},
      deleted: false,
      saved: false
    };
    return state;
  },
  [GETTING_PAGINATED_SEGMENTED_LISTS_SUCCEEDED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: false,
      listsData: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_SEGMENTED_LISTS_FAILED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: false,
      listsData: [],
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [GET_SEGMENTED_LIST]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: true,
      saved: false
    };
    return state;
  },
  [GETTING_SEGMENTED_LIST_SUCCEEDED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: false,
      currentList: { ...action.payload }
    };
    return state;
  },
  [GETTING_SEGMENTED_LIST_FAILED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      getting: false,
      currentList: {},
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [CREATING_SEGMENTED_LIST_SUCCEEDED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      saved: true,
      currentList: { ...action.payload }
    };
    state.showSnackbar = true;
    return state;
  },
  [CREATING_SEGMENTED_LIST_FAILED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      saved: false
    };
    state.showSnackbar = true;
    state.snackbarMessage =
      action.payload.response.status === 409
        ? 'Segmented list name already exists. Try again with a new name.'
        : 'Failed to save. Try again.';
    return state;
  },
  [UPDATING_SEGMENTED_LIST_SUCCEEDED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      saved: true,
      currentList: { ...action.payload }
    };
    state.showSnackbar = true;
    return state;
  },
  [UPDATING_SEGMENTED_LIST_FAILED]: (state, action) => {
    state.segmentedList = {
      ...state.segmentedList,
      saved: false
    };
    state.showSnackbar = true;
    state.snackbarMessage =
      action.payload.response.status === 409
        ? 'Segmented list name already exists. Try again with a new name.'
        : 'Failed to save. Try again.';
    return state;
  },
  [DELETING_SEGMENTED_LIST_SUCCEEDED]: state => {
    state.segmentedList = {
      ...state.segmentedList,
      deleted: true
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Deleted Successfully.';
    state.snackbarSeverity = 'success';
    return state;
  },
  [DELETING_SEGMENTED_LIST_FAILED]: state => {
    state.segmentedList = {
      ...state.segmentedList,
      deleted: false
    };
    state.showSnackbar = true;
    state.snackbarMessage = 'Unable to delete. Try again.';
    state.snackbarSeverity = 'error';
    return state;
  },
  [GET_IMPORT_STATUS_LIST]: (state, action) => {
    state.importStatusList = {
      ...state.importStatusList,
      getting: true
    };
    return state;
  },
  [GETTING_IMPORT_STATUS_LIST_SUCCEEDED]: (state, action) => {
    state.importStatusList = {
      ...state.importStatusList,
      getting: false,
      listsData: action.payload
    };
    return state;
  },
  [GETTING_IMPORT_STATUS_LIST_FAILED]: (state, action) => {
    state.importStatusList = {
      ...state.importStatusList,
      getting: false,
      listsData: [],
      error: {
        message: action.payload.message,
        raw: action.payload
      }
    };
    return state;
  },
  [GET_FILE_NAME_IMPORT_STATUS]: state => {
    state.fileNameStatus = {
      ...state.fileNameStatus,
      getting: true,
      isFileProcessing: false,
      gettingSucceeded: false
    };
    return state;
  },
  [GETTING_FILE_NAME_IMPORT_STATUS_SUCCEEDED]: (state, action) => {
    state.fileNameStatus = {
      ...state.fileNameStatus,
      getting: false,
      isFileProcessing: action.payload.length > 0,
      gettingSucceeded: true
    };
    return state;
  },
  [GETTING_FILE_NAME_IMPORT_STATUS_FAILED]: state => {
    state.fileNameStatus = {
      ...state.fileNameStatus,
      getting: false,
      isFileProcessing: false,
      gettingSucceeded: false
    };
    return state;
  },
  [RESET_GET_FILE_NAME_STATUS]: state => {
    state.fileNameStatus = {
      ...state.fileNameStatus,
      getting: false,
      isFileProcessing: false,
      gettingSucceeded: false
    };
    return state;
  },
  [RESET_IMPORT_SUCCEEDED]: state => {
    state.isImportSucceeded = false;
    return state;
  },
  [GET_ERROR_FILE]: state => {
    state.errorFile = {
      getting: true,
      isDownloading: true,
      gettingSucceeded: false,
      file: {}
    };
    return state;
  },
  [GETTING_ERROR_FILE_SUCCEEDED]: (state, action) => {
    state.errorFile = {
      ...state.errorFile,
      getting: false,
      gettingSucceeded: true,
      file: action.payload
    };
    return state;
  },
  [GETTING_ERROR_FILE_FAILED]: state => {
    state.errorFile = {
      ...state.errorFile,
      getting: false,
      gettingSucceeded: false,
      file: {}
    };
    return state;
  },
  [DOWNLOADED_ERROR_FILE]: state => {
    state.errorFile = {
      ...state.errorFile,
      isDownloading: false,
      gettingSucceeded: false,
      file: {}
    };
    return state;
  },
  [CLEAR_LIST_STORE]: () => {
    return { ...initialState };
  },
  [GET_ALL_LISTS]: state => {
    state.allLists = {
      ...state.allLists,
      getting: true
    };
    return state;
  },
  [GETTING_ALL_LISTS_SUCCEEDED]: (state, action) => {
    state.allLists = {
      ...state.allLists,
      getting: false,
      current: action.payload
    };
    return state;
  },
  [GETTING_ALL_LISTS_FAILED]: state => {
    state.allLists = {
      ...state.allLists,
      getting: false,
      current: []
    };
    return state;
  },
  [GET_ALL_SEGMENTED_LISTS]: state => {
    state.allSegmentedLists = {
      ...state.allSegmentedLists,
      getting: true
    };
    return state;
  },
  [GETTING_ALL_SEGMENTED_LISTS_SUCCEEDED]: (state, action) => {
    state.allSegmentedLists = {
      ...state.allSegmentedLists,
      getting: false,
      current: action.payload
    };
    return state;
  },
  [GETTING_ALL_SEGMENTED_LISTS_FAILED]: state => {
    state.allSegmentedLists = {
      ...state.allSegmentedLists,
      getting: false,
      current: []
    };
    return state;
  },
  [RESET_LISTS_DATA]: state => {
    state.allLists = { ...initialState.allLists };
    state.allSegmentedLists = { ...initialState.allSegmentedLists };
    return state;
  },
  [UPDATE_LIST_FILTERS]: (state, action) => {
    state.subscribersList = {
      ...state.subscribersList,
      getting: true
    };
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_LIST_FILTERS]: state => {
    state.subscribersList = {
      ...state.subscribersList,
      getting: true
    };
    state.filters = { ...initialState.filters };
    return state;
  }
});
